/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Social_OrInputs */

const en_auth_social_or = /** @type {(inputs: Auth_Social_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or continue with`)
};

const es_auth_social_or = /** @type {(inputs: Auth_Social_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O continua con`)
};

/**
* | output |
* | --- |
* | "Or continue with" |
*
* @param {Auth_Social_OrInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_social_or = /** @type {((inputs?: Auth_Social_OrInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Social_OrInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_social_or(inputs)
	return es_auth_social_or(inputs)
});